import { format, formatDistanceToNow, isValid, parseISO } from 'date-fns';

import { ISupportTask } from '../../api/interfaces/support/task';
import {
  TASK_ID_IN_TEXT_PATTERN,
  TASK_STATE,
  TaskState,
} from '../../constants/support-task';
import { HUMAN_DATE_TIME_FORMAT } from '../../constants/time';

export const extractTaskId = (value: unknown) => {
  if (typeof value !== 'string') {
    return '';
  }
  const match = value.match(TASK_ID_IN_TEXT_PATTERN);
  if (!match) {
    return value.trim();
  }
  return match[0].toLowerCase();
};

export const getTaskState = (task: ISupportTask): TaskState => {
  const {
    deletedAt,
    isRecurring,
    isScheduled,
    distributedTotal,
    distributedAt,
  } = task;
  if (deletedAt) {
    return TASK_STATE.DELETED;
  }
  if (isRecurring) {
    return TASK_STATE.RECURRING;
  }
  if (isScheduled) {
    return TASK_STATE.SCHEDULED;
  }
  if (distributedTotal || distributedAt) {
    return TASK_STATE.DISTRIBUTED;
  }
  return TASK_STATE.NOT_SENT;
};

export const humanDate = (value?: string) => {
  if (!value) {
    return undefined;
  }
  const date = parseISO(value);
  if (!isValid(date)) {
    return String(value);
  }
  return `${format(date, HUMAN_DATE_TIME_FORMAT)} (${formatDistanceToNow(date, {
    addSuffix: true,
  })})`;
};
